import { Box, Link, Typography } from "@mui/material";
import MousePosition from "ol/control/MousePosition";
import * as React from "react";
import { useEffect } from "react";
import styled from "styled-components";
import { addMousePositionControl } from "../../lib/layers/interactions/mouse_position";
import DiscordLogo from "../DiscordLogo";
import Flex from "../Flex";
import { useMap } from "./MapCanvas";
import { TerrainHeightLayer } from "./TerrainHeightLayer";

function CursorPosition({ className }) {
  const controlRef = React.useRef<MousePosition>();
  const divRef = React.useRef();
  const map = useMap();

  useEffect(() => {
    if (!map || !divRef.current) {
      return;
    }

    if (controlRef.current) {
      // Already have a control
      return;
    }

    controlRef.current = addMousePositionControl(map, divRef.current);

    return () => {
      map.removeControl(controlRef.current);
    };
  }, [divRef.current, map]);

  return (
    <Flex wide align between className={className}>
      <div className="coords-container">
        <pre ref={divRef} />
      </div>

      <TerrainHeightLayer />
      <Box mr={1}>
        <Flex align between>
          <Box mr={4}>
            <Typography fontSize={12} whiteSpace={"nowrap"}>
              © 2025 Frag Orders, LLC. All rights reserved.
            </Typography>
          </Box>
          <Box mr={4}>
            <Link
              whiteSpace="nowrap"
              target="_blank"
              href="https://docs.fragorders.com"
            >
              Docs
            </Link>
          </Box>
          <Link target="_blank" href="https://discord.gg/mgdk8H9zhX">
            <DiscordLogo />
          </Link>
        </Flex>
      </Box>
    </Flex>
  );
}

export default styled(CursorPosition).attrs({ className: CursorPosition.name })`
  position: absolute;
  bottom: 0px;

  z-index: 3;
  background-color: white;
  word-wrap: nowrap;
  /* Safari abs position + flex bug */

  .coords-container {
    padding: 4px;
    margin-right: 8px;
    flex: 1;

    width: 100%;
    pre {
      margin: 0;
      padding: 0;
    }
  }

  @media only screen and (max-width: 600px) {
    display: none;
  }
`;
